import React from 'react';
import {inject, observer} from 'mobx-react';

export default class Dashboard extends React.Component {
    constructor (props) {
        super(props);
    }
    render () {
        console.log("Testing")
        return (
            <div className="section-title">Coming soon!</div>
        )
    }
}